import React, { useState } from 'react';

import { db } from './firebase'

import { collection, addDoc, serverTimestamp } from "firebase/firestore";
import { useNavigate, useOutletContext, Link } from 'react-router-dom';

export default function CreateHunt() {
    const { uid } = useOutletContext();
    const navigate = useNavigate();

    const [name, setName] = useState("");
    const [busy, setBusy] = useState(false);

    async function handleSubmit(e) {
        e.preventDefault();
        if (!name.trim() || busy) {
            return;
        }
        setBusy(true);

        // Default the hunt to start tomorrow at midnight, matching the old behaviour.
        const defaultDate = new Date();
        defaultDate.setDate(defaultDate.getDate() + 1);
        defaultDate.setHours(0, 0, 0, 0);

        const ref = await addDoc(collection(db, "hunts"), {
            displayName: name.trim(),
            ownerId: uid,
            memberIds: [uid],
            startDate: defaultDate,
            endDate: defaultDate,
            createdAt: serverTimestamp(),
        });

        navigate("/manage/" + ref.id);
    }

    return (
        <div>
            <p><Link to="/">← Back</Link></p>
            <h1>Create a hunt</h1>

            <form onSubmit={handleSubmit}>
                <input
                    placeholder="Hunt name"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <br />
                <button type="submit" disabled={busy}>Create</button>
            </form>
        </div>
    );
}
